import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#272727] py-16 px-8 md:px-[125px]">
      <div className="flex flex-col md:flex-row justify-between gap-12">
        <div>
          <h3 className="text-white text-2xl font-bold mb-4">Sunkissed</h3>
          <p className="text-white/50 text-lg">Homemade Pickles</p>
        </div>

        <div>
          <h3 className="text-white text-xl md:text-2xl font-medium mb-6">
            We are the best for<br />everyday meals.
          </h3>
          <div className="space-y-4">
            <p className="text-white/50 text-lg">Sunkissedtaste@gmail.com</p>
            <p className="text-white/50 text-lg">+91 6263957789</p>
          </div>
        </div>

        <nav>
          <h4 className="text-white/50 text-lg mb-6">Links</h4>
          <ul className="space-y-4">
            <li>
              <Link to="/about" className="text-white text-lg hover:opacity-70">
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-white text-lg hover:opacity-70">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/products" className="text-white text-lg hover:opacity-70">
                Shop
              </Link>
            </li>
            <li>
              <Link to="/bulk-order" className="text-white text-lg hover:opacity-70">
                Be a partner
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <div className="mt-12 pt-6 border-t border-white/20">
        <p className="text-white/50 text-center">
          All rights reserved © 2025 Sunkissed Homemade Pickles
        </p>
      </div>
    </footer>
  );
};

export default Footer;